module.exports = __webpack_public_path__ + "img/8.0ec0d01f.png";